<template>
    <div class="open-ecology">
        <div class="head-box"><navBar :isNav2="true"></navBar></div>
        <div class="content">
            <!-- banner -->
            <div class="banner-box" v-img="{ form: form.bannerObj, key: 'img' }" :style="'background-image: url(' + form.bannerObj.img + ')'">
                <div class="container1" @click.stop>
                    <div class="text-content wow fadeInUp">
                        <p class="name pingFang-Bold font50" v-edit="{ form: form.bannerObj, key: 'title' }">{{ form.bannerObj.title }}</p>
                        <p class="tip-text font24" v-edit="{ form: form.bannerObj, key: 'content' }">{{ form.bannerObj.content }}</p>
                    </div>
                </div>
            </div>
            <!-- 开放生态内容1 -->
            <div class="open-ecology1">
                <div class="container1">
                    <div class="c-title-box  wow fadeInUp">
                        <h2 class="c-title font40" v-edit="{ form: form.firstObj, key: 'title' }">{{ form.firstObj.title }}</h2>
                    </div>
                    <ul class="c-list">
                        <li v-for="(item, key) in form.firstObj.list" :key="key">
                            <div class="c-wrap  wow fadeInUp">
                                <div class="public-img">
                                    <img v-img="{ form: item, key: 'img' }" :src="item.img" alt="" />
                                </div>
                                <div class="c-text-box">
                                    <h3 class="c-title font22" v-edit="{ form: item, key: 'title' }">{{ item.title }}</h3>
                                    <router-link :to="item.url" class="but but-blank but-blank-hover understand-details" type="primary" round>
                                        了解详情&nbsp;
                                        <span class="arrow el-icon-d-arrow-right"></span>
                                    </router-link>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 开放生态内容2 -->
            <!-- <div class="open-ecology2">
				<div class="container1">
					<div class="c-title-box  wow fadeInUp">
						<h2 class="c-title font40" v-edit="{form:form.secoundObj,key:'title'}">{{ form.secoundObj.title }}</h2>
					</div>
					<div class="wow fadeInUp">
						<el-tabs v-model="activeName" >
							<el-tab-pane :label="item.tableName" :name="key+''" v-for="(item,key) in form.secoundObj.list" :key="key">
								<div class="c-wrap">
									<img v-img="{form:item,key:'img'}" :src="item.img" alt="">
									<div class="c-text-box">
										<h3 class="c-title font30" v-edit="{form:item,key:'title'}">{{ item.title }}</h3>
										<ul class="c-list">
											<li>
												<div class="c-box">
													<p class="c-num font60" v-edit="{form:item,key:'number'}">{{ item.number }}</p>
													<p class="c-add font30" v-edit="{form:item,key:'type'}">{{ item.type }}</p>
												</div>
												<p class="c-text" v-edit="{form:item,key:'smallTitle'}">{{ item.smallTitle }}</p>
											</li>
										</ul>
									</div>
								</div>
							</el-tab-pane>
							<div class="c-prev" @click="tabTag1()"><i class="el-icon-arrow-left"></i></div>
							<div class="c-next" @click="tabTag2()"><i class="el-icon-arrow-right"></i></div>
						</el-tabs>
					</div>

				</div>
			</div> -->
        </div>
        <submit-form :form="form" :refComponentId="155" :id="130"></submit-form>
    </div>
</template>

<script>
import navBar from '../components/navBar.vue';
import { initWow } from '@/utils/wow';
import { pageQuery } from '../api/index';
import submitForm from '../components/submit-form.vue';
export default {
    name: '',
    data() {
        return {
            activeName: 0,
            itemLength: 0,
            form: {
                // bannerObj:{
                // 	img:require('../assets/images/ecology-banner.jpg'),
                // 	title:'加入数位开放生态',
                // 	content:'与我们携手并进共赢未来',
                // },
                // firstObj:{
                // 	title:'成为数位官方合作伙伴',
                // 	list:[{
                // 		img:require('../assets/images/ecology1-1.jpg'),
                // 		title:'上上参谋城市服务商',
                // 		url:'/cloudHome',
                // 	},{
                // 		img:require('../assets/images/ecology1-2.jpg'),
                // 		title:'上上参谋企业版代理推广',
                // 		url:'/superiorStaffHome',
                // 	}]
                // },
                // secoundObj:{
                // 	title:'标题名称',
                // 	list:[{
                // 		tableName:'分类名称',
                // 		img:require('../assets/images/ecology2-1.jpg'),
                // 		title:'标题填充标题填充1',
                // 		list:[{
                // 			number:'120',
                // 			type:'+',
                // 			smallTitle:'月均商机'
                // 		},{
                // 			number:'300',
                // 			type:'+',
                // 			smallTitle:'累计服务客户'
                // 		},{
                // 			number:'300',
                // 			type:'+',
                // 			smallTitle:'月均商机'
                // 		},{
                // 			number:'300',
                // 			type:'+',
                // 			smallTitle:'累计服务客户'
                // 		}]
                // 	},{
                // 		tableName:'分类名称',
                // 		img:require('../assets/images/ecology2-1.jpg'),
                // 		title:'标题填充标题填充1',
                // 		list:[{
                // 			number:'120',
                // 			type:'+',
                // 			smallTitle:'月均商机'
                // 		},{
                // 			number:'300',
                // 			type:'+',
                // 			smallTitle:'累计服务客户'
                // 		},{
                // 			number:'300',
                // 			type:'+',
                // 			smallTitle:'月均商机'
                // 		},{
                // 			number:'300',
                // 			type:'+',
                // 			smallTitle:'累计服务客户'
                // 		}]
                // 	},{
                // 		tableName:'分类名称',
                // 		img:require('../assets/images/ecology2-1.jpg'),
                // 		title:'标题填充标题填充1',
                // 		list:[{
                // 			number:'120',
                // 			type:'+',
                // 			smallTitle:'月均商机'
                // 		},{
                // 			number:'300',
                // 			type:'+',
                // 			smallTitle:'累计服务客户'
                // 		},{
                // 			number:'300',
                // 			type:'+',
                // 			smallTitle:'月均商机'
                // 		},{
                // 			number:'300',
                // 			type:'+',
                // 			smallTitle:'累计服务客户'
                // 		}]
                // 	}]
                // }
            }
        };
    },
    mounted() {
        pageQuery({ componentId: '155', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
            this.$nextTick(() => {
                initWow();
                setTimeout(() => {
                    $('.open-ecology2 .el-tabs__item').mouseenter(function() {
                        $(this).click();
                    });
                    this.itemLength = $('.open-ecology2 .el-tabs__item').length;
                }, 500);
            });
        });
    },
    methods: {
        tabTag1() {
            if (this.activeName != 0) {
                $('.open-ecology2 .el-tabs__item')
                    .eq(Number(this.activeName) - 1)
                    .click();
            }
        },
        tabTag2() {
            if (this.activeName != this.itemLength) {
                $('.open-ecology2 .el-tabs__item')
                    .eq(Number(this.activeName) + 1)
                    .click();
            }
        }
    },
    components: { navBar, submitForm }
};
</script>

<style scoped lang="less">
::v-deep .navBar-box {
    z-index: 100;
    background: #fff;
    .navbar .nav-link {
        color: #333333;
    }
    .navbar .right-box .el-dropdown-link,
    .navbar {
        color: #333;
    }
    .navbar .nav-link .arrow {
        background-image: url(../assets/images/arrow-down2.svg);
    }
    .navbar .navbar-toggler .icon-caidan {
        color: #333;
    }
    .navbar .navbar-collapse {
        @media @max-sm {
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            padding: 0 20px;
            background: #fff;
            overflow: hidden;
        }
    }
    .left-box {
        @media @max-sm {
            display: flex;
            align-items: center;
            height: 60px;
        }
    }
}
.open-ecology {
    .head-box {
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: #ffffff;
    }
    // banner
    .banner-box {
        width: 100%;
        height: 600px;
        box-sizing: border-box;
        padding: 80px 0 0 0;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        @media @max-xs {
            height: 100vw;
        }
        .text-content {
            text-align: center;
            color: #fff;
        }
    }
    // 开放生态内容1
    .open-ecology1 {
        padding: 140px 0 120px;
        text-align: center;
        @media @max-xs {
            padding: 60px 0;
        }
        .c-title-box {
            margin-bottom: 40px;
            @media @max-xs {
                margin-bottom: 30px;
            }
            .c-title {
                font-weight: bold;
                margin-bottom: 0;
            }
        }
        .c-list {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -25px -40px;
            li {
                padding: 0 25px 40px;
                width: 50%;
                @media @max-xs {
                    width: 100%;
                }
                .c-wrap {
                    .public-img {
                        border-radius: 10px;
                        &::before {
                            padding-top: 66.568%;
                        }
                    }
                    .c-text-box {
                        position: relative;
                        z-index: 2;
                        margin: -45px 40px 0;
                        padding: 30px;
                        background: #fff;
                        border-radius: 5px;
                        box-shadow: 0 4px 40px rgba(50, 50, 51, 0.06);
                        @media @max-sm {
                            margin: -45px 20px 0;
                        }
                        .c-title {
                            margin-bottom: 30px;
                            font-weight: bold;
                            line-height: 1.5;
                        }
                    }
                    &:hover {
                        .public-img {
                            img {
                                transform: scale(1.05);
                            }
                        }
                    }
                }
            }
        }
        .but {
            display: inline-block;
            color: #eb5405;
            background-color: #eb5405;
            padding: 16px 40px;
            font-size: 16px;
            border: none;
            border-radius: 35px;
            transition: all 0.3s;
            @media @max-xs {
                padding: 10px 15px;
            }
        }
        .but-blank {
            background: none;
            border: thin solid #eb5405;
        }
        .but-blank-hover:hover {
            background-color: #eb5405;
            color: #fff;
        }
    }
    // 开放生态内容2
    .open-ecology2 {
        padding: 125px 0;
        background: #fafafa;
        @media @max-xs {
            padding: 60px 0;
        }
        .c-title-box {
            text-align: center;
            .c-title {
                font-weight: bold;
                margin-bottom: 0;
            }
        }
        ::v-deep {
            .el-tabs__header {
                margin: 30px 0 60px;
                @media @max-xs {
                    margin: 30px 0;
                }
            }
            .el-tabs .el-tabs__header .el-tabs__nav-wrap {
                &::after {
                    display: none;
                }
                .el-tabs__active-bar {
                    display: none;
                }

                .el-tabs__nav-scroll {
                    display: flex;
                    align-items: flex-start;
                    justify-content: center;
                    @media @max-xs {
                        display: block;
                    }
                    .el-tabs__item {
                        margin-right: 40px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        padding: 15px;
                        height: 56px;
                        width: 190px;
                        border: 1px solid #e7e7e7;
                        border-radius: 28px;
                        color: #333;
                        font-size: 20px;
                        transition: all 0.3s;
                        @media @max-sm {
                            margin-right: 20px;
                        }
                        @media @max-xs {
                            font-size: 16px;
                            padding: 10px;
                            height: 46px;
                            width: 110px;
                        }
                        &:last-child {
                            margin-right: 0;
                        }
                        &.is-active {
                            background: #eb5405;
                            border-color: #eb5405;
                            color: #fff;
                        }
                    }
                }
            }
            .el-tab-pane {
                .c-wrap {
                    position: relative;
                    min-height: 520px;
                    border-radius: 10px;
                    overflow: hidden;
                    @media @max-sm {
                        min-height: auto;
                    }
                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        z-index: 1;
                    }
                    .c-text-box {
                        position: relative;
                        z-index: 2;
                        width: 100%;
                        max-width: 530px;
                        padding: 100px;
                        color: #fff;
                        @media @max-xs {
                            padding: 30px;
                        }
                        .c-list {
                            display: flex;
                            flex-wrap: wrap;
                            justify-content: space-between;
                            padding-top: 10px;
                            margin: 0 -20px;
                            @media @max-xs {
                                padding-top: 0;
                            }
                            li {
                                padding: 40px 20px 0;
                                @media @max-xs {
                                    padding: 20px 20px 0;
                                }
                                .c-box {
                                    display: flex;
                                    align-items: flex-end;
                                    .c-num {
                                        font-weight: bold;
                                        line-height: 1;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .el-tabs__content {
                overflow: visible;
            }
            .c-prev,
            .c-next {
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                position: absolute;
                top: 50%;
                width: 60px;
                height: 60px;
                transform: translateY(-50%);
                border-radius: 50%;
                box-shadow: 0 4px 40px rgba(50, 51, 51, 0.11);
                color: #eb5405;
            }
            .c-prev {
                left: -80px;
            }
            .c-next {
                right: -80px;
            }
        }
    }
}
</style>
